// This is considered intentional tech debt. IF we ever want to disable other properties for more companies we
// should abandon this implementation. Do not expand on this with more companies.
// https://linear.app/pocketsolutions/issue/PL-1892/hide-contract-category-from-document-view
import { useAccount } from 'shared/domains/users';
export const companyMetadataConfig = {
    disabledIds: ['e229e981-c862-403f-875a-61a401e56b62'],
    disabledMetadataNames: ['DocumentCategory'],
    disabledSystemProperties: ['category'],
};
/**
 * @deprecated Do not use this component. It is only used for hiding the category for a specific company.
 */
export function CompanyMetadataConfig(props) {
    const { children } = props;
    const { data } = useAccount();
    const { companyId } = data || {};
    if (companyMetadataConfig.disabledIds.includes(companyId)) {
        return null;
    }
    return children;
}
